<template>
<div class="swiper-slide-inner">
    <div class="step">
        <p>STEP<span>04</span></p>
    </div>
    <div class="card">
        <div class="card-inner">

            <div class="question-wrap">
                <h3><span>ショップのコンセプトの登録</span></h3>
                <p>御社のショップのコンセプトを教えて下さい。（250文字以内）</p>
            </div>

            <!--item-->
            <div class="item-wrap">
                <div class="item form_text">
                    <textarea name="shop-concept" id="shop-concept1" maxlength="250" placeholder=" " value=""></textarea>
                    <label for="shop-concept1" class="m-label"><span>ショップコンセプト</span></label>
                </div>
            </div>
        </div>

        <div class="control-wrap">
            <button type="button" class="_left js-swiper-prev"><span>Back</span></button>
            <button type="button" class="_right js-swiper-next"><span>Next</span></button>
        </div>

    </div>
</div>
</template>

